import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CollapseChangeService } from '../../shared/collapse-change.service';
//import { CollapseChangeService } from 'src/app/shared/collapse-change.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  public isCollapsed: boolean = false;
  private didMeetCondition: boolean = false;

  constructor(
    private router: Router,
    private collapseService: CollapseChangeService
  ) {
  }

  ngOnInit(): void {
    this.collapseService.isCollapsed$.subscribe((isCollapsed: boolean) => {
      this.isCollapsed = isCollapsed;
    });
  }

  /*
  ngDoCheck(): void {
    if(this.didMeetCondition) {
      return;
    } else {
      const userData = JSON.parse(localStorage.getItem('0-d0b549ac-2950-4473-9ba3-f46212963e6b')!).userData;
      if(userData) {
        this.didMeetCondition = true;
      }
    }
  }
*/
  onNavigate = (event: string) => {
    this.router.navigate([event]);
  }

  onCollapseChange = (event: boolean) => {
    this.isCollapsed = event;
    this.collapseService.setIsCollapsed(this.isCollapsed);
  }

}
